"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSimpleApi = function (functions) {
    var api = {};
    for (var key in functions) {
        api[key] = buildFunction(functions[key]);
    }
    return api;
};
var buildFunction = function (cFunction) {
    return cFunction.returns + " " + cFunction.name + "(" + buildArguments(cFunction.arguments) + ")";
};
var buildArguments = function (args) {
    if (args) {
        return args.map(function (arg) { return arg.type + " " + arg.name; }).join(", ");
    }
    else {
        return "void";
    }
};
